import { useCallback, useEffect, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";

export const useOrderTracking = (taskId) => {
  const { packkyApi } = useGlobalContext();

  const [orderDetails, setOrderDetails] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  // =====================================================
  // GET RESTAURANT ORDER DETAILS
  // =====================================================

  const fetchRestaurantDetails = useCallback(async () => {
    if (!taskId) {
      setOrderDetails(null);
      setError("");

      return null;
    }

    try {
      setLoading(true);
      setError("");

      const payload = {
        taskId: String(taskId),
      };

      console.log("RESTAURANT DETAILS PAYLOAD:", payload);

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getRestaurantOrderDetails",
        payload,
      );

      console.log("RESTAURANT DETAILS RESPONSE:", res?.data);

      if (res?.data?.responseCode !== "00") {
        throw new Error(
          res?.data?.responseMessage ||
            "Restaurant details fetch nahi ho payi.",
        );
      }

      const data = res?.data?.data || null;

      setOrderDetails(data);

      return data;
    } catch (error) {
      console.error("RESTAURANT DETAILS API ERROR:", error);

      setError(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          error?.message ||
          "Restaurant details fetch nahi ho payi.",
      );

      setOrderDetails(null);

      return null;
    } finally {
      setLoading(false);
    }
  }, [taskId, packkyApi]);

  // =====================================================
  // FIRST LOAD
  // =====================================================

  useEffect(() => {
    if (!taskId) {
      return;
    }

    fetchRestaurantDetails();
  }, [taskId, fetchRestaurantDetails]);

  // =====================================================
  // RETURN
  // =====================================================

  return {
    orderDetails,
    loading,
    error,
    fetchRestaurantDetails,
  };
};
